// Tier-2 <Alert> backed by AntD Alert (FORT-182). Inline success/info/warning/
// error banner. Colour comes from AntD's token-sourced global theme, so success/
// warning/error track the design tokens.
import React from 'react';
import { Alert as AntAlert } from 'antd';
import type { CommonProps } from './types';

export type AlertType = 'success' | 'info' | 'warning' | 'error';

export interface AlertProps extends CommonProps {
  type?: AlertType;
  message: React.ReactNode;
  description?: React.ReactNode;
  showIcon?: boolean;
  closable?: boolean;
  onClose?: () => void;
  action?: React.ReactNode;
  banner?: boolean;
}

export const Alert: React.FC<AlertProps> = ({
  type = 'info',
  message,
  description,
  showIcon = true,
  closable,
  onClose,
  action,
  banner,
  className,
  style,
  'data-testid': dataTestId,
}) => (
  <AntAlert
    type={type}
    message={message}
    description={description}
    showIcon={showIcon}
    closable={closable}
    onClose={onClose}
    action={action}
    banner={banner}
    className={className}
    style={style}
    data-testid={dataTestId}
  />
);
